import { Option } from '../../shared/models/option.model';

const NOMBRES_PROVINCIAS: string[] = [
  'Araba/Álava', 'Albacete', 'Alicante', 'Almería', 'Ávila', 'Badajoz', 'Illes Balears', 'Barcelona', 'Burgos',
  'Cáceres', 'Cádiz', 'Castellón', 'Ciudad Real', 'Córdoba', 'A Coruña', 'Cuenca', 'Girona', 'Granada',
  'Guadalajara', 'Gipuzkoa', 'Huelva', 'Huesca', 'Jaén', 'León', 'Lleida', 'La Rioja', 'Lugo', 'Madrid',
  'Málaga', 'Murcia', 'Navarra', 'Ourense', 'Asturias', 'Palencia', 'Las Palmas', 'Pontevedra', 'Salamanca',
  'Santa Cruz de Tenerife', 'Cantabria', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo',
  'Valencia', 'Valladolid', 'Bizkaia', 'Zamora', 'Zaragoza', 'Ceuta', 'Melilla'
];

export const PROVINCIAS_AEAT: Option[] = NOMBRES_PROVINCIAS.map((nombre, indice) => {
  const codigo = (indice + 1).toString().padStart(2, '0');

  return { label: `${codigo} - ${nombre}`, value: codigo };
});

export const PROVINCIAS_AEAT_NO_RESIDENTES: Option[] = [
  ...PROVINCIAS_AEAT,
  { label: '99 - No residentes', value: '99' }
];

export const SINO_AEAT: Option[] = [
  { label: 'No', value: 'N' },
  { label: 'Sí', value: 'S' }
];
